import React from 'react';
import LazyImage from './LazyImage';

const PageBanner = React.memo((props) => {
    return (
        <div className='welcomeBarHeight babyGreen smoothTransition textDarkPurple md:px-10 px-4 rounded-3xl flex items-center justify-between navAnimation  m-auto'>
            <div className=' text-left'>
                <h1 className=' md:text-5xl text-xl font-bold'>{props.pageName}</h1>
                <p className=' text-gray-500 font-semibold'>{props.pageTitle}</p>
            </div>
            <LazyImage className='  w-36' src={props.src} alt={props.alt} />
        </div>
    );
});

export default PageBanner;
